export const invalidPasswordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!%*#?&]{8,}$/

export const passwordRequirementText =
  'Must contain 8 characters, including at least one uppercase, one lowercase, and a number.'
